import mapboxgl from 'mapbox-gl'
import { scrollToMember } from '../controllers/members-list'

const MAPBOX_TOKEN =
  'pk.eyJ1IjoidmluY2VudDEiLCJhIjoiY2loMGw5aHgxMDBpbm5kbTdtMjhkZmV4diJ9.gbe0SgUsplLaH8da4e4v7A'

const ACTIVE_CLASS = 'is-active'

let Map
let MapLayer
let Popups
let Popup

const MAP_OPTIONS = {
  zoom: 4,
  center: [17.5, 61.5],
}

export default class {
  constructor(el, options) {
    Map = new mapboxgl.Map({
      // style: 'mapbox://styles/mapbox/streets-v12',
      style: 'mapbox://styles/mapbox/standard',
      container: el,
      accessToken: MAPBOX_TOKEN,
      maxZoom: 20,
      minZoom: 4,
      center: MAP_OPTIONS.center,
      zoom: MAP_OPTIONS.zoom,
      attributionControl: false,
      maxBounds: [
        [7, 52], // SW
        [33, 67], // NE
      ],
    })

    const data = document.querySelector('.js-mapData')
    const json = JSON.parse(data.innerHTML)

    Map.on('load', () => {
      Map.loadImage(
        '/app/themes/rikskriscentrum/assets/images/pin.png',
        (error, image) => {
          if (error) throw error

          Map.addImage('icon', image)

          Map.addSource('members', {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: json.map((item) => ({
                type: 'Feature',
                properties: {
                  id: item.id,
                  title: item.member_title,
                  description: item.member_location.address,
                },
                geometry: {
                  type: 'Point',
                  coordinates: [
                    item.member_location.lng,
                    item.member_location.lat,
                  ],
                },
              })),
            },
          })

          MapLayer = Map.addLayer({
            id: 'members',
            type: 'circle',
            source: 'members',
            paint: {
              'circle-color': '#0066C7',
              'circle-radius': 8,
              'circle-stroke-width': 3,
              'circle-stroke-color': '#ffffff',
            },
          })

          Map.on('click', 'members', (e) => {
            const coordinates = e.features[0].geometry.coordinates.slice()
            const featureData = e.features[0].properties

            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
              coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
            }

            Popup = new mapboxgl.Popup({
              closeButton: false,
              offset: 8,
            })
              .setLngLat(coordinates)
              .setHTML(
                `<div><span class="Map-popupTitle">${featureData.title}</span><span class="Map-popupText">${featureData.description}</span></div>`,
              )
              .addTo(Map)

            const id = featureData.id

            const onPopupClick = () => {
              scrollToMember(id)
            }

            Popup.getElement().addEventListener('click', onPopupClick, {
              once: true,
            })
          })

          el.parentNode.classList.add(ACTIVE_CLASS)
        },
      )

      Map.on('mouseenter', 'members', () => {
        Map.getCanvas().style.cursor = 'pointer'
      })

      Map.on('mouseleave', 'members', () => {
        Map.getCanvas().style.cursor = ''
      })
    })
  }
}

export function zoomToLocation(id) {
  if (!Map) {
    return
  }

  if (id) {
    const features = Map.querySourceFeatures('members', {
      sourceLayer: 'members',
    })

    const target = features.find((feature) => feature.properties.id === id)

    if (target) {
      Map.easeTo({
        center: target.geometry.coordinates,
        zoom: 5,
        duration: 400,
        easing: (x) => 1 - (1 - x) * (1 - x),
      })

      if (Popup) {
        Popup.remove()
      }

      Popup = new mapboxgl.Popup({
        closeButton: false,
        offset: 8,
      })
        .setLngLat(target.geometry.coordinates)
        // .setHTML(target.properties.description)
        .setHTML(
          `<div><span class="Map-popupTitle">${target.properties.title}</span><span class="Map-popupText">${target.properties.description}</span></div>`,
        )
        .addTo(Map)

      return
    } else {
      Map.zoomTo(MAP_OPTIONS.zoom, {
        duration: 400,
      })

      setTimeout(() => {
        zoomToLocation(id)
      }, 450)
    }
  } else {
    Map.setView(MAP_OPTIONS.center, MAP_OPTIONS.zoom)
  }
}
